let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("hQ32H")).then(() => parcelRequire('idjoc'));